import AppName from 'config/AppName';

import ItemBase from './ItemBase';

const AppItem = () => {
  return <ItemBase text={AppName}></ItemBase>;
};

export default AppItem;
